<template>
	<main class="payment-failed-history">
		<header>
			<h1>{{ customerFullName }} | {{ data.failedAt }} </h1>
			<h2 v-if="paymentMethodText"><span class="label">Payment method</span>: {{ paymentMethodText }}</h2>
			<h2 v-if="bankText"><span class="label">Bank</span>: {{ bankText }}</h2>
			<h2 v-if="data.installmentInterestRate"><span class="label">Installment period</span>: {{ data.installmentInterestRate }}% ({{ data.installmentTerm }} Months)</h2>
		</header>
		<article class="content">
			<p class="message">
				{{ messageText }}

				<template v-if="data.failurePortal">
					(<a :href="data.failurePortal" target="_blank">{{ data.failureCode }}</a>)
				</template>
			</p>
			<p class="by">By <span class="name">{{ bankText }} </span>| {{ data.failedAt }}</p>
		</article>
	</main>
</template>

<script>
export default {
	name: 'PaymentFailedHistory',
	props: {
		data: {
			type: Object,
			required: true,
		},
		orderDetail: {
			type: Object,
			required: true,
		},
	},
	computed: {
		customerFullName() {
			return `${this.orderDetail.customer.firstName} ${this.orderDetail.customer.lastName}`;
		},
		paymentMethodText() {
			return this.data.methodName || this.data.method;
		},
		bankText() {
			return this.data.name || this.data.agent;
		},
		messageText() {
			return this.data.failureMessage ?
				this.data.failureMessage
				: `Unknown message please get in touch with customer service (${this.bankText})`;
		},
	},
};
</script>

<style scoped lang="scss">
.payment-failed-history {
	&:not(:last-child) {
		padding-bottom: 16px;
		border-bottom: 1px solid $color-gray-100;
		margin-bottom: 16px;
	}
}

header {
	h1 {
		font-size: rem(14);
		line-height: rem(20);
		font-weight: 600;
		margin-bottom: 8px;
	}

	h2 {
		font-size: rem(14);
		line-height: rem(20);
		font-weight: 400;
		margin-bottom: 0;

		> .label {
			color: $color-gray-500;
			font-weight: 400;
		}

		&:last-child {
			margin-bottom: 8px;
		}
	}
}

.content {
	background-color: $color-gray-100;
	border-radius: 4px;
	padding: 12px 16px;
	border: 1px solid $color-gray-100;

	.credit-no,
	.price,
	.message {
		font-size: rem(14);
		line-height: rem(20);
		font-weight: 600;
		color: $color-black;
		margin-bottom: 0;
	}

	.status {
		font-size: rem(12);
		line-height: rem(20);
		color: $color-black;
		margin-bottom: 0;
	}

	.by {
		font-size: rem(12);
		line-height: rem(20);
		color: $color-gray-500;
		margin-bottom: 0;

		.name {
			color: $color-primary;
		}
	}
}
</style>
